import React from 'react';
import { Card } from '../ui/Card';
import { Clock, BarChart3, Building2, Zap } from 'lucide-react';
const benefits = [{
  icon: Building2,
  title: 'Fără drumuri la bancă',
  description: 'Totul se întâmplă online. Nu mai pierzi timpul la ghișee sau completând dosare fizice interminabile.'
}, {
  icon: BarChart3,
  title: 'Analiză transparentă',
  description: 'Vezi exact de ce ești eligibil și compari ofertele în mod obiectiv, bazat pe cifre reale.'
}, {
  icon: Zap,
  title: 'Proces rapid',
  description: 'De la aplicare până la ofertă, totul este optimizat pentru viteză. Știm că banii sunt importanți acum.'
}, {
  icon: Clock,
  title: 'Finanțare potrivită',
  description: 'Nu îți vindem ce avem, ci găsim ce îți trebuie. Matching inteligent între nevoile tale și produsele băncilor.'
}];
export function Benefits() {
  return <section id="benefits" className="py-24 bg-white" data-id="element-74">
      <div className="container mx-auto px-4 md:px-6" data-id="element-75">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-76">
          <div data-id="element-77">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-78">
              De ce să alegi platforma noastră?
            </h2>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-79">
              Suntem partenerul tău în relația cu băncile. Negociem, simplificăm
              și accelerăm procesul pentru ca tu să te ocupi de afacerea ta.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-80">
              {benefits.map((benefit, index) => <Card key={index} hover className="border-slate-100 bg-slate-50/50" data-id="element-81">
                  <benefit.icon className="h-8 w-8 text-blue-600 mb-4" data-id="element-82" />
                  <h3 className="font-bold text-slate-900 mb-2" data-id="element-83">
                    {benefit.title}
                  </h3>
                  <p className="text-sm text-slate-600 leading-relaxed" data-id="element-84">
                    {benefit.description}
                  </p>
                </Card>)}
            </div>
          </div>

          <div className="relative" data-id="element-85">
            <div className="absolute inset-0 bg-gradient-to-tr from-blue-100 to-indigo-50 rounded-3xl transform rotate-3 scale-105 -z-10" data-id="element-86" />
            <img src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1632&q=80" alt="Meeting" className="rounded-3xl shadow-2xl w-full object-cover h-[600px]" data-id="element-87" />

            {/* Floating Stats Card */}
            <div className="absolute bottom-8 left-8 bg-white p-6 rounded-xl shadow-xl max-w-xs animate-in slide-in-from-bottom-10 fade-in duration-700" data-id="element-88">
              <div className="flex items-center gap-4 mb-4" data-id="element-89">
                <div className="h-10 w-10 rounded-full bg-green-100 flex items-center justify-center" data-id="element-90">
                  <Zap className="h-5 w-5 text-green-600" data-id="element-91" />
                </div>
                <div data-id="element-92">
                  <p className="text-sm text-slate-500" data-id="element-93">Timp mediu aprobare</p>
                  <p className="text-xl font-bold text-slate-900" data-id="element-94">48 Ore</p>
                </div>
              </div>
              <div className="w-full bg-slate-100 h-2 rounded-full overflow-hidden" data-id="element-95">
                <div className="bg-green-500 h-full w-[85%]" data-id="element-96" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}